import { Alert, Typography } from 'antd'
import RatingSystemForm from 'components/Main/RatingSystem/RatingSystemForm'
import FormSectionTitle from 'elements/FormSectionTitle'
import React from 'react'
import CustomSpin from '../../../../elements/CustomSpin'

const { Paragraph } = Typography

function AddRatingSystem(props) {
  const { fetching, formRef, template, data, isNew } = props

  console.log(123, data, isNew)
  return (
    <CustomSpin spinning={fetching}>
      <FormSectionTitle title={template.name} />
      {template.description && (
        <div className="mb-5">
          <Paragraph>{template.description}</Paragraph>
        </div>
      )}
      {isNew && (
        <div className="px-20 py-5">
          <Alert
            message="New Survey"
            description="Info Description Info Description Info Description Info Description"
            type="info"
          />
        </div>
      )}
      <RatingSystemForm ref={formRef} {...props} />
    </CustomSpin>
  )
}

export default AddRatingSystem
